export interface BaseKlantDetails {
    handelsnaam?: string;
    naam: string;
    tussenvoegsel: string;

    aanspreekvorm: Aanspreekvorm;

    geslacht: string;
    voornamen: string;
    roepnaam: string;
    voorletters: string;
    geboortenaam: string;
    geboorte_oprichtings_datum: string;
    tussenvoegsel_geboortenaam: string;
    tussenvoegsel_partnernaam: string;
    partnernaam: string;

    adres: Adres;
    verzend_adres?: Adres;

    heeft_afwijkend_adres: boolean;
    afwijkend_adres_land?: string;
    afwijkend_adres_1?: string;
    afwijkend_adres_2?: string;
    afwijkend_adres_3?: string;
}

export interface KlantDetails extends BaseKlantDetails {
    combinedName: string;
}

export interface Adres {
    straat: string;
    huisnummer: string;
    huisnummer_suffix: string;
    postcode: string;
    woonplaats: string;
    land: string;
}

export enum Aanspreekvorm {
    geboortenaam = 'geboortenaam',
    geboortenaamPartnernaam = 'geboortenaam_partnernaam',
    partnernaam = 'partnernaam',
    partnernaamGeboortenaam = 'partnernaam_geboortenaam'
}
